import {FormFieldRegistration} from "../field-registration";
export class FormioBase {
    public key: string;
    public inputType: string;
    public type: string;
    public title: string;
    public parentTitle: string;
    public label: string;
    public icon: string;
    public schema: any;
    public reusable = true;
    public jsonDeterminants = "[]";
    public registrations: FormFieldRegistration[];
    public parentComponent: string;
    public systemCodes: string[] = [];
    public shouldBeRenderedByFormio: boolean = true;
    public isAvailable: boolean = true;
    public components: FormioBase[] = [];
    public rows: FormioBase[] = [];
    public isRequired() {
        return this.schema
            && this.schema.components
            && this.schema.components[0]
            && this.schema.components[0].validate
            && this.schema.components[0].validate.required;
    }
    public toHtml() { return null; } // override to create custom render for component
}
